import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';

import { HttpCode } from 'types';
import { HTTP_CODE } from 'common/constants';
import { HttpError } from 'utils/http-error';
import { getStores } from './api';
import { Store, StoresList } from '../types';

type InitialState = {
  activeStore: Store | null;
  data: StoresList | null;
  isError: boolean;
  errorCode: HttpCode | null;
};

const initialState: InitialState = {
  activeStore: null,
  data: null,
  isError: false,
  errorCode: null,
};

const fetchStoresThunk = createAsyncThunk('stores/FETCH_STORES', getStores);

const { actions, reducer } = createSlice({
  name: 'stores',
  initialState,
  reducers: {
    setActiveStore: (state: InitialState, { payload }: PayloadAction<Store | null>) => {
      state.activeStore = payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchStoresThunk.pending, (state) => {
        state.activeStore = null;
        state.data = null;
        state.isError = false;
        state.errorCode = null;
      })
      .addCase(fetchStoresThunk.fulfilled, (state, { payload }) => {
        state.activeStore = null;
        if (Object.keys(payload as StoresList).length) {
          state.data = payload as StoresList;
          state.isError = false;
          state.errorCode = null;
        } else {
          state.data = null;
          state.isError = true;
          state.errorCode = HTTP_CODE.SERVER_ERROR;
        }
      })
      .addCase(fetchStoresThunk.rejected, (state, { payload }) => {
        state.activeStore = null;
        state.data = null;
        state.isError = true;
        state.errorCode = payload as HttpCode;
        throw new HttpError(payload as HttpCode);
      });
  },
});

const { setActiveStore } = actions;

export { setActiveStore, reducer, fetchStoresThunk };
